import { Component } from '@angular/core';
import { IToast, ToastService } from './services/toast.service';

@Component({
  selector: 'sgt-toast-container',
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.scss']
})
export class ToastContainerComponent {
  toasts$ = this.toastService.toasts$;

  constructor(public toastService: ToastService) {}

  trackById(_: number, toast: IToast): number {
    return toast.id;
  }
}
